/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCategory = /* GraphQL */ `
  mutation CreateCategory(
    $input: CreateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    createCategory(input: $input, condition: $condition) {
      id
      name
      subline
      description
      colour
      icon
      careers {
        nextToken
        __typename
      }
      questions {
        nextToken
        __typename
      }
      video
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCategory = /* GraphQL */ `
  mutation UpdateCategory(
    $input: UpdateCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    updateCategory(input: $input, condition: $condition) {
      id
      name
      subline
      description
      colour
      icon
      careers {
        nextToken
        __typename
      }
      questions {
        nextToken
        __typename
      }
      video
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCategory = /* GraphQL */ `
  mutation DeleteCategory(
    $input: DeleteCategoryInput!
    $condition: ModelCategoryConditionInput
  ) {
    deleteCategory(input: $input, condition: $condition) {
      id
      name
      subline
      description
      colour
      icon
      careers {
        nextToken
        __typename
      }
      questions {
        nextToken
        __typename
      }
      video
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCareer = /* GraphQL */ `
  mutation CreateCareer(
    $input: CreateCareerInput!
    $condition: ModelCareerConditionInput
  ) {
    createCareer(input: $input, condition: $condition) {
      id
      name
      description
      categoryID
      archive
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      video
      relatedCareersBridges {
        nextToken
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCareer = /* GraphQL */ `
  mutation UpdateCareer(
    $input: UpdateCareerInput!
    $condition: ModelCareerConditionInput
  ) {
    updateCareer(input: $input, condition: $condition) {
      id
      name
      description
      categoryID
      archive
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      video
      relatedCareersBridges {
        nextToken
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCareer = /* GraphQL */ `
  mutation DeleteCareer(
    $input: DeleteCareerInput!
    $condition: ModelCareerConditionInput
  ) {
    deleteCareer(input: $input, condition: $condition) {
      id
      name
      description
      categoryID
      archive
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      video
      relatedCareersBridges {
        nextToken
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRelatedCareer = /* GraphQL */ `
  mutation CreateRelatedCareer(
    $input: CreateRelatedCareerInput!
    $condition: ModelRelatedCareerConditionInput
  ) {
    createRelatedCareer(input: $input, condition: $condition) {
      id
      type
      name
      description
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRelatedCareer = /* GraphQL */ `
  mutation UpdateRelatedCareer(
    $input: UpdateRelatedCareerInput!
    $condition: ModelRelatedCareerConditionInput
  ) {
    updateRelatedCareer(input: $input, condition: $condition) {
      id
      type
      name
      description
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRelatedCareer = /* GraphQL */ `
  mutation DeleteRelatedCareer(
    $input: DeleteRelatedCareerInput!
    $condition: ModelRelatedCareerConditionInput
  ) {
    deleteRelatedCareer(input: $input, condition: $condition) {
      id
      type
      name
      description
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createQuestion = /* GraphQL */ `
  mutation CreateQuestion(
    $input: CreateQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    createQuestion(input: $input, condition: $condition) {
      id
      description
      categoryID
      type
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      set
      number
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuestion = /* GraphQL */ `
  mutation UpdateQuestion(
    $input: UpdateQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    updateQuestion(input: $input, condition: $condition) {
      id
      description
      categoryID
      type
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      set
      number
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuestion = /* GraphQL */ `
  mutation DeleteQuestion(
    $input: DeleteQuestionInput!
    $condition: ModelQuestionConditionInput
  ) {
    deleteQuestion(input: $input, condition: $condition) {
      id
      description
      categoryID
      type
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      set
      number
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRelatedCareersBridge = /* GraphQL */ `
  mutation CreateRelatedCareersBridge(
    $input: CreateRelatedCareersBridgeInput!
    $condition: ModelRelatedCareersBridgeConditionInput
  ) {
    createRelatedCareersBridge(input: $input, condition: $condition) {
      id
      careerID
      relatedCareerID
      career {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      relatedCareer {
        id
        type
        name
        description
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRelatedCareersBridge = /* GraphQL */ `
  mutation UpdateRelatedCareersBridge(
    $input: UpdateRelatedCareersBridgeInput!
    $condition: ModelRelatedCareersBridgeConditionInput
  ) {
    updateRelatedCareersBridge(input: $input, condition: $condition) {
      id
      careerID
      relatedCareerID
      career {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      relatedCareer {
        id
        type
        name
        description
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRelatedCareersBridge = /* GraphQL */ `
  mutation DeleteRelatedCareersBridge(
    $input: DeleteRelatedCareersBridgeInput!
    $condition: ModelRelatedCareersBridgeConditionInput
  ) {
    deleteRelatedCareersBridge(input: $input, condition: $condition) {
      id
      careerID
      relatedCareerID
      career {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      relatedCareer {
        id
        type
        name
        description
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStudent = /* GraphQL */ `
  mutation CreateStudent(
    $input: CreateStudentInput!
    $condition: ModelStudentConditionInput
  ) {
    createStudent(input: $input, condition: $condition) {
      id
      userID
      username
      name
      surname
      age
      email
      phone_number
      gradeID
      schoolID
      grade {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      school {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      sponsors {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStudent = /* GraphQL */ `
  mutation UpdateStudent(
    $input: UpdateStudentInput!
    $condition: ModelStudentConditionInput
  ) {
    updateStudent(input: $input, condition: $condition) {
      id
      userID
      username
      name
      surname
      age
      email
      phone_number
      gradeID
      schoolID
      grade {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      school {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      sponsors {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStudent = /* GraphQL */ `
  mutation DeleteStudent(
    $input: DeleteStudentInput!
    $condition: ModelStudentConditionInput
  ) {
    deleteStudent(input: $input, condition: $condition) {
      id
      userID
      username
      name
      surname
      age
      email
      phone_number
      gradeID
      schoolID
      grade {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      school {
        id
        name
        status
        createdAt
        updatedAt
        __typename
      }
      sponsors {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createGrade = /* GraphQL */ `
  mutation CreateGrade(
    $input: CreateGradeInput!
    $condition: ModelGradeConditionInput
  ) {
    createGrade(input: $input, condition: $condition) {
      id
      name
      status
      students {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateGrade = /* GraphQL */ `
  mutation UpdateGrade(
    $input: UpdateGradeInput!
    $condition: ModelGradeConditionInput
  ) {
    updateGrade(input: $input, condition: $condition) {
      id
      name
      status
      students {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteGrade = /* GraphQL */ `
  mutation DeleteGrade(
    $input: DeleteGradeInput!
    $condition: ModelGradeConditionInput
  ) {
    deleteGrade(input: $input, condition: $condition) {
      id
      name
      status
      students {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSchool = /* GraphQL */ `
  mutation CreateSchool(
    $input: CreateSchoolInput!
    $condition: ModelSchoolConditionInput
  ) {
    createSchool(input: $input, condition: $condition) {
      id
      name
      status
      students {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSchool = /* GraphQL */ `
  mutation UpdateSchool(
    $input: UpdateSchoolInput!
    $condition: ModelSchoolConditionInput
  ) {
    updateSchool(input: $input, condition: $condition) {
      id
      name
      status
      students {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSchool = /* GraphQL */ `
  mutation DeleteSchool(
    $input: DeleteSchoolInput!
    $condition: ModelSchoolConditionInput
  ) {
    deleteSchool(input: $input, condition: $condition) {
      id
      name
      status
      students {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSponsor = /* GraphQL */ `
  mutation CreateSponsor(
    $input: CreateSponsorInput!
    $condition: ModelSponsorConditionInput
  ) {
    createSponsor(input: $input, condition: $condition) {
      id
      name
      logo
      license_count
      code
      content
      address {
        addressLine1
        addressLine2
        suburb
        city
        province
        __typename
      }
      contact {
        phoneNumber
        emailAddress
        websiteURL
        __typename
      }
      students {
        nextToken
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSponsor = /* GraphQL */ `
  mutation UpdateSponsor(
    $input: UpdateSponsorInput!
    $condition: ModelSponsorConditionInput
  ) {
    updateSponsor(input: $input, condition: $condition) {
      id
      name
      logo
      license_count
      code
      content
      address {
        addressLine1
        addressLine2
        suburb
        city
        province
        __typename
      }
      contact {
        phoneNumber
        emailAddress
        websiteURL
        __typename
      }
      students {
        nextToken
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSponsor = /* GraphQL */ `
  mutation DeleteSponsor(
    $input: DeleteSponsorInput!
    $condition: ModelSponsorConditionInput
  ) {
    deleteSponsor(input: $input, condition: $condition) {
      id
      name
      logo
      license_count
      code
      content
      address {
        addressLine1
        addressLine2
        suburb
        city
        province
        __typename
      }
      contact {
        phoneNumber
        emailAddress
        websiteURL
        __typename
      }
      students {
        nextToken
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSponsorStudentBridge = /* GraphQL */ `
  mutation CreateSponsorStudentBridge(
    $input: CreateSponsorStudentBridgeInput!
    $condition: ModelSponsorStudentBridgeConditionInput
  ) {
    createSponsorStudentBridge(input: $input, condition: $condition) {
      id
      sponsorID
      studentID
      code
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      result {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSponsorStudentBridge = /* GraphQL */ `
  mutation UpdateSponsorStudentBridge(
    $input: UpdateSponsorStudentBridgeInput!
    $condition: ModelSponsorStudentBridgeConditionInput
  ) {
    updateSponsorStudentBridge(input: $input, condition: $condition) {
      id
      sponsorID
      studentID
      code
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      result {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSponsorStudentBridge = /* GraphQL */ `
  mutation DeleteSponsorStudentBridge(
    $input: DeleteSponsorStudentBridgeInput!
    $condition: ModelSponsorStudentBridgeConditionInput
  ) {
    deleteSponsorStudentBridge(input: $input, condition: $condition) {
      id
      sponsorID
      studentID
      code
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      result {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createResults = /* GraphQL */ `
  mutation CreateResults(
    $input: CreateResultsInput!
    $condition: ModelResultsConditionInput
  ) {
    createResults(input: $input, condition: $condition) {
      id
      studentID
      sponsorStudentBridgeID
      file
      progress
      expiryDate
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      sponsorStudentBridge {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      responses {
        nextToken
        __typename
      }
      feedback {
        nextToken
        __typename
      }
      resultCategories {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateResults = /* GraphQL */ `
  mutation UpdateResults(
    $input: UpdateResultsInput!
    $condition: ModelResultsConditionInput
  ) {
    updateResults(input: $input, condition: $condition) {
      id
      studentID
      sponsorStudentBridgeID
      file
      progress
      expiryDate
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      sponsorStudentBridge {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      responses {
        nextToken
        __typename
      }
      feedback {
        nextToken
        __typename
      }
      resultCategories {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteResults = /* GraphQL */ `
  mutation DeleteResults(
    $input: DeleteResultsInput!
    $condition: ModelResultsConditionInput
  ) {
    deleteResults(input: $input, condition: $condition) {
      id
      studentID
      sponsorStudentBridgeID
      file
      progress
      expiryDate
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      sponsorStudentBridge {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      responses {
        nextToken
        __typename
      }
      feedback {
        nextToken
        __typename
      }
      resultCategories {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createResultCategory = /* GraphQL */ `
  mutation CreateResultCategory(
    $input: CreateResultCategoryInput!
    $condition: ModelResultCategoryConditionInput
  ) {
    createResultCategory(input: $input, condition: $condition) {
      id
      resultID
      score
      categoryID
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateResultCategory = /* GraphQL */ `
  mutation UpdateResultCategory(
    $input: UpdateResultCategoryInput!
    $condition: ModelResultCategoryConditionInput
  ) {
    updateResultCategory(input: $input, condition: $condition) {
      id
      resultID
      score
      categoryID
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteResultCategory = /* GraphQL */ `
  mutation DeleteResultCategory(
    $input: DeleteResultCategoryInput!
    $condition: ModelResultCategoryConditionInput
  ) {
    deleteResultCategory(input: $input, condition: $condition) {
      id
      resultID
      score
      categoryID
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        subline
        description
        colour
        icon
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFeedbackQuestion = /* GraphQL */ `
  mutation CreateFeedbackQuestion(
    $input: CreateFeedbackQuestionInput!
    $condition: ModelFeedbackQuestionConditionInput
  ) {
    createFeedbackQuestion(input: $input, condition: $condition) {
      id
      description
      type
      number
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFeedbackQuestion = /* GraphQL */ `
  mutation UpdateFeedbackQuestion(
    $input: UpdateFeedbackQuestionInput!
    $condition: ModelFeedbackQuestionConditionInput
  ) {
    updateFeedbackQuestion(input: $input, condition: $condition) {
      id
      description
      type
      number
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFeedbackQuestion = /* GraphQL */ `
  mutation DeleteFeedbackQuestion(
    $input: DeleteFeedbackQuestionInput!
    $condition: ModelFeedbackQuestionConditionInput
  ) {
    deleteFeedbackQuestion(input: $input, condition: $condition) {
      id
      description
      type
      number
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFeedback = /* GraphQL */ `
  mutation CreateFeedback(
    $input: CreateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    createFeedback(input: $input, condition: $condition) {
      id
      resultID
      feedbackQuestionID
      sponsorID
      studentID
      feedback
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      feedbackQuestion {
        id
        description
        type
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFeedback = /* GraphQL */ `
  mutation UpdateFeedback(
    $input: UpdateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    updateFeedback(input: $input, condition: $condition) {
      id
      resultID
      feedbackQuestionID
      sponsorID
      studentID
      feedback
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      feedbackQuestion {
        id
        description
        type
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFeedback = /* GraphQL */ `
  mutation DeleteFeedback(
    $input: DeleteFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    deleteFeedback(input: $input, condition: $condition) {
      id
      resultID
      feedbackQuestionID
      sponsorID
      studentID
      feedback
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      feedbackQuestion {
        id
        description
        type
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createResponse = /* GraphQL */ `
  mutation CreateResponse(
    $input: CreateResponseInput!
    $condition: ModelResponseConditionInput
  ) {
    createResponse(input: $input, condition: $condition) {
      id
      resultID
      questionID
      studentID
      sponsorStudentBridgeID
      response
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      question {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      sponsorStudentBridge {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateResponse = /* GraphQL */ `
  mutation UpdateResponse(
    $input: UpdateResponseInput!
    $condition: ModelResponseConditionInput
  ) {
    updateResponse(input: $input, condition: $condition) {
      id
      resultID
      questionID
      studentID
      sponsorStudentBridgeID
      response
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      question {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      sponsorStudentBridge {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteResponse = /* GraphQL */ `
  mutation DeleteResponse(
    $input: DeleteResponseInput!
    $condition: ModelResponseConditionInput
  ) {
    deleteResponse(input: $input, condition: $condition) {
      id
      resultID
      questionID
      studentID
      sponsorStudentBridgeID
      response
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      question {
        id
        description
        categoryID
        type
        set
        number
        t
        version
        createdAt
        updatedAt
        __typename
      }
      student {
        id
        userID
        username
        name
        surname
        age
        email
        phone_number
        gradeID
        schoolID
        createdAt
        updatedAt
        __typename
      }
      sponsorStudentBridge {
        id
        sponsorID
        studentID
        code
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSponsorCode = /* GraphQL */ `
  mutation CreateSponsorCode(
    $input: CreateSponsorCodeInput!
    $condition: ModelSponsorCodeConditionInput
  ) {
    createSponsorCode(input: $input, condition: $condition) {
      id
      sponsorID
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      code
      paymentID
      used
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSponsorCode = /* GraphQL */ `
  mutation UpdateSponsorCode(
    $input: UpdateSponsorCodeInput!
    $condition: ModelSponsorCodeConditionInput
  ) {
    updateSponsorCode(input: $input, condition: $condition) {
      id
      sponsorID
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      code
      paymentID
      used
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSponsorCode = /* GraphQL */ `
  mutation DeleteSponsorCode(
    $input: DeleteSponsorCodeInput!
    $condition: ModelSponsorCodeConditionInput
  ) {
    deleteSponsorCode(input: $input, condition: $condition) {
      id
      sponsorID
      sponsor {
        id
        name
        logo
        license_count
        code
        content
        t
        version
        createdAt
        updatedAt
        __typename
      }
      code
      paymentID
      used
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFavouritedCareer = /* GraphQL */ `
  mutation CreateFavouritedCareer(
    $input: CreateFavouritedCareerInput!
    $condition: ModelFavouritedCareerConditionInput
  ) {
    createFavouritedCareer(input: $input, condition: $condition) {
      id
      resultID
      careerID
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      career {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFavouritedCareer = /* GraphQL */ `
  mutation UpdateFavouritedCareer(
    $input: UpdateFavouritedCareerInput!
    $condition: ModelFavouritedCareerConditionInput
  ) {
    updateFavouritedCareer(input: $input, condition: $condition) {
      id
      resultID
      careerID
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      career {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFavouritedCareer = /* GraphQL */ `
  mutation DeleteFavouritedCareer(
    $input: DeleteFavouritedCareerInput!
    $condition: ModelFavouritedCareerConditionInput
  ) {
    deleteFavouritedCareer(input: $input, condition: $condition) {
      id
      resultID
      careerID
      result {
        id
        studentID
        sponsorStudentBridgeID
        file
        progress
        expiryDate
        createdAt
        updatedAt
        __typename
      }
      career {
        id
        name
        description
        categoryID
        archive
        video
        t
        version
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCareerCentre = /* GraphQL */ `
  mutation CreateCareerCentre(
    $input: CreateCareerCentreInput!
    $condition: ModelCareerCentreConditionInput
  ) {
    createCareerCentre(input: $input, condition: $condition) {
      id
      name
      description
      image
      address {
        addressLine1
        addressLine2
        suburb
        city
        province
        __typename
      }
      contact {
        name
        phoneNumber
        phoneNumber2
        emailAddress
        websiteURL
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCareerCentre = /* GraphQL */ `
  mutation UpdateCareerCentre(
    $input: UpdateCareerCentreInput!
    $condition: ModelCareerCentreConditionInput
  ) {
    updateCareerCentre(input: $input, condition: $condition) {
      id
      name
      description
      image
      address {
        addressLine1
        addressLine2
        suburb
        city
        province
        __typename
      }
      contact {
        name
        phoneNumber
        phoneNumber2
        emailAddress
        websiteURL
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCareerCentre = /* GraphQL */ `
  mutation DeleteCareerCentre(
    $input: DeleteCareerCentreInput!
    $condition: ModelCareerCentreConditionInput
  ) {
    deleteCareerCentre(input: $input, condition: $condition) {
      id
      name
      description
      image
      address {
        addressLine1
        addressLine2
        suburb
        city
        province
        __typename
      }
      contact {
        name
        phoneNumber
        phoneNumber2
        emailAddress
        websiteURL
        __typename
      }
      t
      version
      createdAt
      updatedAt
      __typename
    }
  }
`;
